
import * as React from "react";

interface INewOfferProps {
    order: any
    setUrl: any

}

interface INewOfferState {
}

export default class NewOffer extends React.Component<INewOfferProps, INewOfferState>{

    constructor(props:INewOfferProps){
        super(props);
        this.state = {

        };


    }


    render() {

        if(this.props.order.status.key != 'modify_hour') {
            return (<></>);
        }

        return (
            <div className="row">
                <div className="col-md-12">
                    <div className="order modify-hour">
                        <div className="content">
                            <p className="offer-type">{this.props.order.offer.offerType.name}
                                <span>{this.props.order.hours} hours</span></p>
                            <hr/>
                            <p className="price">{this.props.order.price} {this.props.order.currency}</p>
                        </div>

                    </div>
                </div>
            </div>
        );
    }
}
